module.exports = __webpack_public_path__ + "media/images/responsive/fairs/present_bg_deco-6b5b19b32d66416f7c5c9b5a5f53924b.png";